import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { c as _ } from "../index-rKuIKazb.js";
import m from "../Card/index.js";
import { useTheme as h } from "../ThemeProvider/index.js";
import '../assets/index7.css';const u = "_layout_c2q1c_2", g = "_bold_c2q1c_5", q = "_heading_c2q1c_5", b = "_underline_c2q1c_8", f = "_children_c2q1c_17", p = "_dark_c2q1c_21", c = {
  layout: u,
  bold: g,
  heading: q,
  underline: b,
  children: f,
  dark: p
}, j = (n) => {
  const { bold: d, children: s, className: o, heading: a, underline: l } = n, r = h(), i = _(
    c[r],
    c.layout,
    d && c.bold,
    l && c.underline,
    o
  );
  return /* @__PURE__ */ t(m, { className: i, children: [
    /* @__PURE__ */ e("div", { className: c.heading, children: a }),
    /* @__PURE__ */ e("div", { className: c.children, children: s })
  ] });
};
export {
  j as default
};
